// AWS imports removed - using Google Sheets instead

const SESSION_DURATION = 5 * 60 * 1000; // 5 minutes
const MAX_QUOTES_PER_SESSION = 2;
const MAX_APPOINTMENTS_PER_SESSION = 1;
const APPOINTMENT_COOLDOWN = 48 * 60 * 60 * 1000; // 48 hours

export class SessionManager {
  static sessions = new Map();

  static createSession(phoneNumber, fullName) {
    const session = {
      phoneNumber,
      fullName,
      startTime: Date.now(),
      quotesSubmitted: 0,
      appointmentsBooked: 0
    };
    this.sessions.set(phoneNumber, session);
    return session;
  }

  static async checkLastAppointment(phoneNumber) {
    // AWS DynamoDB functionality removed - using Google Sheets instead
    // This method now returns null as appointment checking is handled by Google Sheets
    console.log('Appointment checking now handled by Google Sheets');
    return null;
  }

  static canSubmitQuote(phoneNumber) {
    const session = this.sessions.get(phoneNumber);
    if (!session) return false;
    
    const isSessionValid = (Date.now() - session.startTime) < SESSION_DURATION;
    const hasQuotaLeft = session.quotesSubmitted < MAX_QUOTES_PER_SESSION;
    
    return isSessionValid && hasQuotaLeft;
  }

  static canBookAppointment(phoneNumber) {
    const session = this.sessions.get(phoneNumber);
    if (!session) return false;
    
    const isSessionValid = (Date.now() - session.startTime) < SESSION_DURATION;
    const hasQuotaLeft = session.appointmentsBooked < MAX_APPOINTMENTS_PER_SESSION;
    
    return isSessionValid && hasQuotaLeft;
  }

  static incrementQuotes(phoneNumber) {
    const session = this.sessions.get(phoneNumber);
    if (session) {
      session.quotesSubmitted += 1;
    }
  }

  static incrementAppointments(phoneNumber) {
    const session = this.sessions.get(phoneNumber);
    if (session) {
      session.appointmentsBooked += 1;
    }
  }

  static getSession(phoneNumber) {
    return this.sessions.get(phoneNumber);
  }
} 